import React from 'react';
import { useState, useEffect, useCallback } from "react";
import Notification from "../components/Notification";
import dayjs from 'dayjs';
import { getBranches, getBookingsList, getAvailableSlotss, getAddons, createPaymentLinkApi, updateBookingStatus, createPaymentApi, updateBookingById } from "../api/reusableApis";
import {
    FiSearch, FiChevronDown, FiFilter, FiMoreHorizontal, FiCheck
} from "react-icons/fi";
import Modal from "../components/modal";
import Popover from "../components/ui/Popover";
import BasicDatePicker from '../components/BasicDatePicker';
import { useSelector } from 'react-redux';
import { FiCalendar, FiClock, FiPhone, FiSend, FiChevronRight, FiCheckCircle, FiDollarSign, FiLink } from 'react-icons/fi';

const status = [
    {
        "key": "PENDING",
        "value": "Pending"
    },
    {
        "key": "BOOKED",
        "value": "Booked"
    },
    {
        "key": "COMPLETED",
        "value": "Completed"
    },
    {
        "key": "REFUNDED",
        "value": "Refunded"
    },
    {
        "key": "CANCELED",
        "value": "Canceled"
    }
];
const limit = 20;
const ListBookings = () => {
    const currentLoggedInUser = useSelector((state) => state.auth.currentUser);
    const [loader, setLoader] = useState(true);
    const [toast, setToast] = useState({ message: "", type: "success" });
    const [search, setSearch] = useState("");
    const [branch, setBranch] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('PENDING');
    const [selectedRange, setSelectedRange] = useState('all'); // Default value
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [bookingList, setBookingList] = useState([]);
    const [mode, setMode] = useState("view");
    const [openModal, setOpenModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState({});
    const [timeSlots, setTimeSlots] = useState([]);
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [offset, setOffset] = useState(0);

    const [selectedAddons, setSelectedAddons] = useState([]);
    const [addons, setAddons] = useState([]);
    const [openPaymentModal, setOpenPaymentModal] = useState(false);
    const [balanceAmount, setBalanceAmount] = useState('');
    const [newTotalAmount, setNewTotalAmount] = useState(0);
    const [extraAmtDue, setExtraAmtDue] = useState(0);
    const [deletedAddons, setDeletedAddons] = useState([]);
    const [addonTotalAmt, setAddonTotalAmt] = useState(0);
    const [telecallerId, setTelecallerId] = useState('');

    const isLastPage = !bookingList || bookingList.length < 20;

    // 3. Navigation handlers
    const handleNextPage = () => {
        if (!isLastPage) setOffset(prev => prev + 20);
    };

    const handlePrevPage = () => {
        setOffset(prev => Math.max(0, prev - 20));
    };

    const handleExtraAmt = (e) => {
        setExtraAmtDue(e);
        var newTotal = Number(e) + Number(balanceAmount);
        setNewTotalAmount(newTotal);
    }

    const fetchBranch = useCallback(async (id = '') => {
        try {
            setLoader(true);
            var branches = await getBranches(true);
            if (currentLoggedInUser.role_details.role_name == "App User") {
                branches = branches.filter((branch) => {
                    return branch.ROWID == currentLoggedInUser.users.branch_id;
                })
            }
            setBranch(branches);
            setLoader(false);
            if (branches && branches.length > 0) {
                const firstBranchId = branches[0]['ROWID'];
                setSelectedBranch(firstBranchId);
                fetchAllAddons(firstBranchId, true);
            }
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }, []);

    const onRangeSelected = (range) => {
        setSelectedRange(range);

        const now = new Date();
        let from = '';
        let to = '';

        // ✅ Timezone-safe date formatter (NO toISOString)
        const formatDate = (date) => {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        };

        switch (range) {
            case 'all':
                from = '';
                to = '';
                break;

            case 'today': {
                from = formatDate(now);
                to = formatDate(now);
                break;
            }

            case 'yesterday': {
                const y = new Date(now);      // ✅ clone
                y.setDate(y.getDate() - 1);
                from = formatDate(y);
                to = formatDate(y);
                break;
            }

            case 'this_week': {
                const today = new Date(now);  // ✅ clone

                const start = new Date(today);
                start.setDate(today.getDate() - today.getDay()); // Sunday

                const end = new Date(start);
                end.setDate(start.getDate() + 6); // Saturday

                from = formatDate(start);
                to = formatDate(end);
                break;
            }

            case 'this_month': {
                const start = new Date(now.getFullYear(), now.getMonth(), 1);
                const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

                from = formatDate(start);
                to = formatDate(end);
                break;
            }

            case 'this_year': {
                const start = new Date(now.getFullYear(), 0, 1);
                const end = new Date(now.getFullYear(), 11, 31);

                from = formatDate(start);
                to = formatDate(end);
                break;
            }

            case 'custom':
                return;

            default:
                break;
        }

        setDateFrom(from);
        setDateTo(to);
    };



    const fetchBookingList = async (branch_id, status, telecaller_id, text, from_date = '', to_date = '', offset = '') => {
        try {
            const bookingList = await getBookingsList(branch_id, status, telecaller_id, text, from_date, to_date, offset);
            const sortedList = bookingList.sort((a, b) => {
                const dateA = new Date(a.booking.created_date);
                const dateB = new Date(b.booking.created_date);
                return dateA - dateB;
            });

            setBookingList(sortedList);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (currentLoggedInUser?.role_details?.role_name === 'App User') {
            setTelecallerId(currentLoggedInUser?.users?.ROWID);
            fetchBranch(currentLoggedInUser?.users?.ROWID);
        } else if (currentLoggedInUser?.role_details?.role_name === 'App Administrator') {
            fetchBranch();
        }
        onRangeSelected('all')
    }, [currentLoggedInUser]);

    useEffect(() => {
        fetchBookingList(selectedBranch, selectedStatus, telecallerId, search, dateFrom, dateTo, offset);
    }, [dateFrom, dateTo, selectedBranch, selectedStatus, search, telecallerId, offset, selectedRange])

    function onBranchSelected(branch_id) {
        setSelectedBranch(branch_id);
        fetchAllAddons(branch_id, true);
    }

    async function onsearch(text) {
        setSearch(text);
    }


    const closeModal = () => {
        setOpenModal(false);
        setErrors({});
        setSelectedBooking({})
        setMode("");
        setFormData({})
    };

    const closePaymentModal = () => {
        setSelectedBooking({})
        setOpenPaymentModal(false);
        setFormData({});
    }

    const markComplete2 = async (booking) => {
        var bookingDetails = booking['booking'];
        var booking_id = bookingDetails['ROWID'];
        let requestObj = {
            "ROWID": booking_id,
            "status": "BOOKED"
        }

        var updateBooking = await updateBookingStatus(requestObj, booking_id);
        if (updateBooking?.data?.success === true) {
            let requestBody = {
                amount: Number(bookingDetails['advance_amount']),
                payment_method: "Cash",
                notes: "Advance Payment",
                status: "completed"
            }
            var createPayment = await createPaymentApi(requestBody, booking_id);
            console.log(createPayment, 'createPayment');
            if (createPayment?.data?.success === true) {
                fetchBookingList(selectedBranch, selectedStatus, telecallerId, search, dateFrom, dateTo, offset);
                setToast({
                    message: "Payment completed successfully..",
                    type: "success",
                });
            } else if (createPayment?.data?.success === false) {
                setToast({
                    message: createPayment?.data?.message || 'Unable to create a payment.',
                    type: "error",
                });
            }
        } else {
            setToast({
                message: updateBooking?.data?.message || 'Unable to update booking record.',
                type: "error",
            });
        }
    }
    const markComplete = async (newTotal) => {
        console.log(extraAmtDue, 'extra_amt');
        console.log(newTotal, 'new total');
        var booking_id = selectedBooking?.booking?.ROWID;
        console.log(selectedBooking, 'selected booking');
        let requestObj = {
            "ROWID": booking_id,
            "extra_amt": Number(extraAmtDue),
            "total_amount": Number(extraAmtDue) + Number(selectedBooking?.booking?.total_amount),
            "status": "COMPLETED"
        }

        var updateBooking = await updateBookingStatus(requestObj, booking_id);
        if (updateBooking?.data?.success === true) {
            let requestBody = {
                amount: Number(newTotal),
                payment_method: "Cash",
                notes: "Balance Payment",
                status: "completed"
            }
            var createPayment = await createPaymentApi(requestBody, booking_id);
            console.log(createPayment, 'createPayment');
            if (createPayment?.data?.success === true) {
                closePaymentModal();
                fetchBookingList(selectedBranch, selectedStatus, telecallerId, search, dateFrom, dateTo, offset);
                setToast({
                    message: "Payment completed successfully..",
                    type: "success",
                });
            } else if (createPayment?.data?.success === false) {
                closePaymentModal();
                setToast({
                    message: createPayment?.data?.message || 'Unable to create a payment.',
                    type: "error",
                });
            }
        } else {
            closePaymentModal();
            setToast({
                message: updateBooking?.data?.message || 'Unable to update booking record.',
                type: "error",
            });
        }
    }

    const sendPaymentLink = async (status) => {
        console.log(formData);
        console.log(selectedBooking);
        if (status === 'PENDING') {
            setLoader(true);
            var order_id = `ORDER_${formData['ROWID']}`;

            let requestObj = {
                "orderId": order_id,
                "amount": Number(formData['advance_amount']),
                "customerName": formData['customer_name'],
                "email": formData['customer_email'],
                "mobile": formData['customer_phone'],
                "booking_id": formData['ROWID'],
                "status": status,
                "notes": {
                    "booking_id": formData['ROWID']
                }
            }

            var paymentDetails = await createPaymentLinkApi(requestObj);
            console.log(paymentDetails, 'payment details');
            setLoader(false);
            setOpenPaymentModal(false);
            if (paymentDetails?.data?.success === true) {
                setToast({
                    message: "Payment Link Sent to Customer",
                    type: "success",
                });
            } else if (paymentDetails?.data?.success === false) {
                setToast({
                    message: paymentDetails?.data?.message || 'Unable to create a payment link.',
                    type: "error",
                });
            } else {
                setToast({
                    message: "Something went wrong, Contact Administrator.",
                    type: "error",
                });
            }
        } else if (status === 'BOOKED') {
            setLoader(true);
            var order_id = `ORDER_${formData['ROWID']}`;
            let requestObj = {
                "orderId": order_id,
                "amount": Number(newTotalAmount),
                "customerName": formData['customer_name'],
                "email": formData['customer_email'],
                "mobile": formData['customer_phone'],
                "booking_id": formData['ROWID'],
                "status": status,
                "notes": {
                    "booking_id": formData['ROWID'],
                    "extraAmount": extraAmtDue
                }
            }

            var paymentDetails = await createPaymentLinkApi(requestObj);
            console.log(paymentDetails, 'payment details');
            setLoader(false);
            setOpenPaymentModal(false);
            if (paymentDetails?.data?.success === true) {
                setToast({
                    message: "Payment Link Sent to Customer",
                    type: "success",
                });
            } else if (paymentDetails?.data?.success === false) {
                setToast({
                    message: paymentDetails?.data?.message || 'Unable to create a payment link.',
                    type: "error",
                });
            } else {
                setToast({
                    message: "Something went wrong, Contact Administrator.",
                    type: "error",
                });
            }
        }
    }

    function onStatusSelected(status) {
        setSelectedStatus(status);
    }


    const handlePayment = (booking) => {
        setSelectedBooking(booking);

        console.log(booking);
        if (booking?.['booking']['status'] === 'PENDING') {
            let formObj = {
                customer_name: booking?.['booking']['customer_name'],
                customer_email: booking?.['booking']['customer_email'],
                customer_phone: booking?.['booking']['customer_phone'],
                cake_note: booking?.['booking']['cake_note'],
                notes: booking?.['booking']['notes'],
                booking_date: booking?.booking?.booking_date || dayjs(),
                package_amount: booking?.['booking']['package_amount'],
                advance_amount: booking?.['booking']['advance_amount'],
                total_amount: booking?.['booking']['total_amount'],
                balance_amount: booking?.['booking']['balance_amount'],
                status: booking?.['booking']['status'],
                time_slot_id: booking?.['booking']['time_slot_id'],
                ROWID: booking?.['booking']['ROWID']
            }
            setFormData(formObj);
            setOpenPaymentModal(true);
        } else if (booking?.['booking']['status'] === 'BOOKED') {
            let formObj = {
                customer_name: booking?.['booking']['customer_name'],
                customer_email: booking?.['booking']['customer_email'],
                customer_phone: booking?.['booking']['customer_phone'],
                cake_note: booking?.['booking']['cake_note'],
                notes: booking?.['booking']['notes'],
                booking_date: booking?.booking?.booking_date || dayjs(),
                package_amount: booking?.['booking']['package_amount'],
                advance_amount: booking?.['booking']['advance_amount'],
                total_amount: booking?.['booking']['total_amount'],
                balance_amount: booking?.['booking']['balance_amount'],
                status: booking?.['booking']['status'],
                time_slot_id: booking?.['booking']['time_slot_id'],
                ROWID: booking?.['booking']['ROWID']
            }
            setFormData(formObj);
            setOpenPaymentModal(true);
            setExtraAmtDue(0);
            setBalanceAmount(booking?.['booking']['balance_amount']);
            setNewTotalAmount(booking?.['booking']['balance_amount']);
        }
    }

    const handleEdit = async (booking) => {
        setSelectedBooking(booking);  // Set the full addon object
        setMode('edit');
        let formObj = {
            customer_name: booking?.['booking']['customer_name'],
            customer_email: booking?.['booking']['customer_email'],
            customer_phone: booking?.['booking']['customer_phone'],
            cake_note: booking?.['booking']['cake_note'],
            notes: booking?.['booking']['notes'],
            booking_date: booking?.booking?.booking_date || dayjs(),
            package_amount: booking?.['booking']['package_amount'],
            advance_amount: booking?.['booking']['advance_amount'],
            total_amount: booking?.['booking']['total_amount'],
            balance_amount: booking?.['booking']['balance_amount'],
            status: booking?.['booking']['status'],
            time_slot_id: booking?.['booking']['time_slot_id']
        }

        if (booking?.addons?.length > 0) {
            var k = booking?.addons?.map(a => ({ ROWID: a.ROWID, addon_id: a.addon_id, addon_name: a.name, price: Number(a.price), quantity: Number(a.quantity), line_total: Number(a.line_total), isExisting: true }));
            setSelectedAddons(k);
        }
        setAddonTotalAmt(booking?.booking?.addons_amount);
        // setSelectedTimeSlots(booking?.timeSlot);
        var branch_id = booking?.['booking']['branch_id'];
        var package_id = booking?.['booking']['package_id'];
        var booking_date = booking?.['booking']['booking_date'];
        var stimeslots = await fetchTimeSlots(branch_id, package_id, booking_date);

        if (booking.booking.status == "BOOKED") {
            stimeslots.push({ ...booking?.timeSlot, time_slot_id: booking?.timeSlot.ROWID });
            setTimeSlots(stimeslots);
        }
        setFormData(formObj);

        setOpenModal(true);

    };

    const fetchTimeSlots = useCallback(async (branch_id, package_id, booking_date) => {
        try {
            setLoader(true);
            const timeSlots = await getAvailableSlotss(branch_id, package_id, booking_date);
            var filteredtimeslots = timeSlots?.data?.slots.filter((t) => {
                return t.is_available;
            })
            setTimeSlots(filteredtimeslots);
            setLoader(false);
            return filteredtimeslots;
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }, []);


    const fetchAllAddons = useCallback(async (selectedBranch, status) => {
        try {
            setLoader(true);
            console.log(selectedBranch, 'selectedBranch');
            const addons = await getAddons(selectedBranch, status);
            setAddons(addons);
            setLoader(false);
            console.log(addons, 'addons');
        } catch (error) {
            console.error(error);
            setLoader(false);
        }
    }, []);

    const handleView = (booking) => {
        setSelectedBooking(booking);  // Set the full addon object
        setMode('view');
        let formObj = {
            customer_name: booking?.['booking']['customer_name'],
            customer_email: booking?.['booking']['customer_email'],
            customer_phone: booking?.['booking']['customer_phone'],
            cake_note: booking?.['booking']['cake_note'],
            notes: booking?.['booking']['notes'],
            booking_date: booking?.booking?.booking_date || dayjs(),
            package_amount: booking?.['booking']['package_amount'],
            advance_amount: booking?.['booking']['advance_amount'],
            total_amount: booking?.['booking']['total_amount'],
            balance_amount: booking?.['booking']['balance_amount'],
            status: booking?.['booking']['status'],
            time_slot_id: booking?.['booking']['time_slot_id']
        }
        setFormData(formObj);
        setSelectedAddons(booking?.addons);
        setAddonTotalAmt(booking?.booking?.addons_amount);
        var branch_id = booking?.['booking']['branch_id'];
        var package_id = booking?.['booking']['package_id'];
        var booking_date = booking?.['booking']['booking_date'];
        fetchTimeSlots(branch_id, package_id, booking_date);
        setOpenModal(true);
    };


    const updateBookings = async () => {
        setLoader(true);
        const booking_id = selectedBooking?.['booking']['ROWID'];
        const payload = { ...formData, ROWID: booking_id };

        // Filter for only brand new addons
        const newAddons = selectedAddons
            ?.filter(addon => !addon.isExisting)
            .map(addon => ({
                booking_id: booking_id,
                addon_id: addon.addon_id,
                addon_name: addon.addon_name,
                price: addon.price,
                quantity: addon.quantity,
                line_total: addon.line_total,
            }));

        const requestBody = {
            json: payload,
            deletedAddons: deletedAddons,
            addons: newAddons
        };

        try {
            const response = await updateBookingById(requestBody, booking_id);
            if (response?.data?.success) {
                // UPDATING THE UI LIST HERE:
                fetchBookingList(selectedBranch, selectedStatus, telecallerId, search, dateFrom, dateTo);
                setToast({ message: 'Booking updated successfully.', type: "success" });
            } else {
                setToast({ message: response?.data?.message || 'Update failed.', type: "error" });
            }
        } catch (error) {
            setToast({ message: 'A network error occurred.', type: "error" });
        } finally {
            setLoader(false);
            closeModal();
        }
    }




    useEffect(() => {
        var subTotal = 0;
        selectedAddons?.forEach(addon => {
            subTotal += addon['line_total'];
        });
        setAddonTotalAmt(subTotal);
        setFormData((prev) => {
            const baseAmount = Number(prev.package_amount || 0);
            const advancePaid = Number(prev.advance_amount || 0);
            const totalAmount = baseAmount + subTotal;
            const balanceAmount = totalAmount - advancePaid;

            return {
                ...prev,
                addons_amount: subTotal,
                total_amount: totalAmount,
                balance_amount: balanceAmount
            };
        });
    }, [selectedAddons]);


    const removeAddons = (addon) => {
        if (addon?.isExisting) {
            setDeletedAddons((prev) => [...prev, addon.ROWID]);
        }
    }

    return (
        <>
            {loader ? (
                <div className="flex items-center justify-center min-h-[60vh] w-full">
                    <div className="w-8 h-8 border-4 border-gray-300 border-t-[#72398E] rounded-full animate-spin"></div>
                </div>
            ) :
                <>
                    <Notification
                        message={toast.message}
                        type={toast.type}
                        onClose={() => setToast({ message: "", type: "success" })}
                    />

                    <div className="flex-1 px-4 sm:px-6 py-6 pt-20 lg:pt-6 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen h-screen overflow-y-auto">

                        {/* Header Section */}
                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
                            <div className="max-w-2xl">
                                <h1 className="text-3xl font-black tracking-tight text-[#72398E]">
                                    List Bookings
                                </h1>
                                <p className="text-sm font-medium text-slate-500 mt-2 leading-relaxed">
                                    Manage your schedule effortlessly. Track <span className="text-purple-600">Pending</span>, <span className="text-emerald-600">Booked</span>, and <span className="text-rose-600">Canceled</span> statuses in real-time.
                                </p>
                            </div>
                        </div>
                        {/* Filter Bar */}
                        <div className="bg-white rounded-2xl border border-slate-100 p-5 flex flex-col lg:flex-row gap-4 mb-8 shadow-sm ring-4 ring-slate-50">

                            {/* Search Input */}
                            <div className="relative flex-1 group">
                                <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-[#72398E] transition-colors" />
                                <input
                                    placeholder="Search by customer, phone, or ID..."
                                    value={search}
                                    onChange={(e) => onsearch(e.target.value)}
                                    className="w-full bg-slate-50 border border-slate-200 rounded-xl pl-11 pr-4 py-3 text-sm outline-none focus:bg-white focus:border-[#72398E] focus:ring-4 focus:ring-purple-50 transition-all"
                                />
                            </div>

                            {/* Dropdown Group */}
                            <div className="flex flex-col sm:flex-row flex-wrap lg:flex-nowrap gap-3">

                                {/* Date Range Select Container */}
                                <div className="flex flex-col sm:flex-row gap-3">
                                    <div className="relative min-w-[160px]">
                                        <select
                                            value={selectedRange}
                                            onChange={(e) => onRangeSelected(e.target.value)}
                                            className="w-full h-full appearance-none bg-white border border-slate-200 rounded-xl px-4 py-3 pr-10 text-sm font-semibold text-slate-700 outline-none hover:border-slate-300 focus:border-[#72398E] focus:ring-4 focus:ring-purple-50 transition-all cursor-pointer"
                                        >
                                            <option value="all">All</option>
                                            <option value="today">Today</option>
                                            <option value="yesterday">Yesterday</option>
                                            <option value="this_week">This Week</option>
                                            <option value="this_month">This Month</option>
                                            <option value="this_year">This Year</option>
                                            <option value="custom">Custom Range</option>
                                        </select>
                                        <FiCalendar className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
                                    </div>

                                    {/* Conditional Custom Date Inputs (From & To) */}
                                    {selectedRange === 'custom' && (
                                        <div className="flex items-center gap-2 animate-in fade-in slide-in-from-left-2 duration-300">
                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    value={dateFrom}
                                                    onChange={(e) => setDateFrom(e.target.value)}
                                                    className="bg-white border border-slate-200 rounded-xl px-3 py-3 text-xs font-semibold text-slate-700 outline-none focus:border-[#72398E] focus:ring-4 focus:ring-purple-50 transition-all"
                                                />
                                                <span className="absolute -top-2 left-3 bg-white px-1 text-[10px] text-slate-400 uppercase font-bold">From</span>
                                            </div>

                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    value={dateTo}
                                                    onChange={(e) => setDateTo(e.target.value)}
                                                    className="bg-white border border-slate-200 rounded-xl px-3 py-3 text-xs font-semibold text-slate-700 outline-none focus:border-[#72398E] focus:ring-4 focus:ring-purple-50 transition-all"
                                                />
                                                <span className="absolute -top-2 left-3 bg-white px-1 text-[10px] text-slate-400 uppercase font-bold">To</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Branch Select */}
                                <div className="relative min-w-[160px]">
                                    <select
                                        value={selectedBranch}
                                        onChange={(e) => onBranchSelected(e.target.value)}
                                        className="w-full h-full appearance-none bg-white border border-slate-200 rounded-xl px-4 py-3 pr-10 text-sm font-semibold text-slate-700 outline-none hover:border-slate-300 focus:border-[#72398E] focus:ring-4 focus:ring-purple-50 transition-all cursor-pointer"
                                    >
                                        {branch.map((r) => (
                                            <option key={r.ROWID} value={r.ROWID}>{r.name}</option>
                                        ))}
                                    </select>
                                    <FiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
                                </div>

                                {/* Status Select */}
                                <div className="relative min-w-[150px]">
                                    <select
                                        value={selectedStatus}
                                        onChange={(e) => onStatusSelected(e.target.value)}
                                        className="w-full h-full appearance-none bg-white border border-slate-200 rounded-xl px-4 py-3 pr-10 text-sm font-semibold text-slate-700 outline-none hover:border-slate-300 focus:border-[#72398E] focus:ring-4 focus:ring-purple-50 transition-all cursor-pointer"
                                    >
                                        {status.map((r) => (
                                            <option key={r.key} value={r.key}>{r.value}</option>
                                        ))}
                                    </select>
                                    <FiFilter className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" />
                                </div>
                            </div>
                        </div>
                        <div className="w-full space-y-4">
                            {/* --- MOBILE VIEW: Card Layout (Visible < 768px) --- */}

                            <div className="grid grid-cols-1 gap-6 md:hidden px-3 pt-4">
                                {bookingList && bookingList.length > 0 ? (
                                    bookingList.map((booking) => (
                                        <div
                                            key={booking.booking.ROWID}
                                            className="bg-white rounded-[2rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 overflow-hidden"
                                        >
                                            {/* Header Status Strip */}
                                            <div className="px-6 py-4 flex justify-between items-center bg-slate-50/50 border-b border-slate-50">
                                                <div className="flex items-center gap-2">
                                                    <div className={`w-2 h-2 rounded-full ${booking.booking.status === 'BOOKED' ? 'bg-[#72398E] animate-pulse' : 'bg-amber-400'
                                                        }`} />
                                                    <span className="text-[11px] font-black uppercase tracking-widest text-slate-400">
                                                        #{booking.booking.ROWID.slice(-6)}
                                                    </span>
                                                </div>
                                                <span className={`px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-tighter ${booking.booking.status === 'BOOKED'
                                                    ? 'bg-purple-100 text-[#72398E]'
                                                    : 'bg-amber-100 text-amber-700'
                                                    }`}>
                                                    {booking.booking.status}
                                                </span>
                                            </div>

                                            <div className="p-6">
                                                {/* Customer Info Section */}
                                                <div className="flex justify-between items-start mb-6">
                                                    <div>
                                                        <h3 className="font-extrabold text-slate-900 text-xl tracking-tight">
                                                            {booking.booking.customer_name}
                                                        </h3>
                                                        <a href={`tel:${booking.booking.customer_phone}`} className="flex items-center gap-1.5 text-[#72398E] text-sm font-semibold mt-1">
                                                            <FiPhone size={14} />
                                                            {booking.booking.customer_phone}
                                                        </a>
                                                    </div>
                                                    <div className="text-right">
                                                        <span className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1">Total</span>
                                                        <span className="text-xl font-black text-slate-900">₹{booking.booking.total_amount}</span>
                                                    </div>
                                                </div>

                                                {/* Meta Data Grid (Glassmorphism look) */}
                                                <div className="grid grid-cols-2 gap-4 p-4 bg-slate-50 rounded-2xl mb-6">
                                                    <div className="space-y-1">
                                                        <span className="flex items-center gap-1.5 text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                                                            <FiCalendar className="text-[#72398E]" /> Date
                                                        </span>
                                                        <span className="text-sm font-bold text-slate-700">{booking.booking.booking_date}</span>
                                                    </div>
                                                    <div className="space-y-1">
                                                        <span className="flex items-center gap-1.5 text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                                                            <FiClock className="text-[#72398E]" /> Slot
                                                        </span>
                                                        <span className="text-sm font-bold text-slate-700">{booking.timeSlot?.label}</span>
                                                    </div>

                                                    <div className="space-y-1">
                                                        <span className="flex items-center gap-1.5 text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                                                            Package Name
                                                        </span>
                                                        <span className="text-sm font-bold text-slate-700">{booking.package.name}</span>
                                                    </div>
                                                    <div className="space-y-1">
                                                        <span className="flex items-center gap-1.5 text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                                                            Telecaller
                                                        </span>
                                                        <span className="text-sm font-bold text-slate-700">{booking.booking.telecaller_id !== null ? booking?.user?.name : "Admin"}</span>
                                                    </div>

                                                </div>

                                                {/* Dynamic Action Buttons */}
                                                <div className="space-y-3">
                                                    {/* PRIMARY ACTIONS: Payment Links & Status Updates */}
                                                    <div className="flex flex-col gap-2">
                                                        {(booking.booking.status === 'PENDING' || booking.booking.status === 'BOOKED') && (
                                                            <>
                                                                {/* THE BILL LINK CTA */}
                                                                <button
                                                                    onClick={() => handlePayment(booking)}
                                                                    className="w-full flex items-center justify-center gap-3 py-4 px-4 rounded-2xl bg-[#72398E] text-white text-sm font-black shadow-lg shadow-purple-100 active:scale-[0.98] transition-all"
                                                                >
                                                                    <FiSend size={18} />
                                                                    <span className="flex-1 text-left">
                                                                        {booking.booking.status === 'PENDING' ? 'Send Advance Link' : 'Send Bill Link'}
                                                                    </span>
                                                                    <FiChevronRight className="opacity-50" />
                                                                </button>

                                                                {/* MARK AS PAID BUTTON */}
                                                                {booking.booking.status === 'PENDING' ? <>
                                                                    <button
                                                                        onClick={() => markComplete2(booking)}
                                                                        className="w-full flex items-center justify-center gap-3 py-3.5 px-4 rounded-2xl bg-emerald-50 text-emerald-700 border border-emerald-100 text-sm font-bold hover:bg-emerald-600 hover:text-white transition-all active:scale-[0.98]"
                                                                    >
                                                                        <div className="bg-emerald-500 text-white rounded-full p-0.5">
                                                                            <FiCheck size={14} strokeWidth={3} />
                                                                        </div>
                                                                        Mark as Paid
                                                                    </button>
                                                                </> : ''}
                                                            </>
                                                        )}
                                                    </div>

                                                    {/* SECONDARY ACTIONS: View & Edit */}
                                                    <div className="flex gap-3">
                                                        <button
                                                            onClick={() => handleView(booking)}
                                                            className="flex-1 py-3 rounded-xl bg-white border border-slate-200 text-slate-500 text-[11px] font-black uppercase tracking-widest hover:bg-slate-50 hover:text-slate-800 transition-colors"
                                                        >
                                                            View Details
                                                        </button>
                                                        {(selectedStatus === 'PENDING' || selectedStatus === 'BOOKED') && (
                                                            <button
                                                                onClick={() => handleEdit(booking)}
                                                                className="flex-1 py-3 rounded-xl bg-white border border-slate-200 text-slate-500 text-[11px] font-black uppercase tracking-widest hover:bg-slate-50 hover:text-slate-800 transition-colors"
                                                            >
                                                                Edit Booking
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="flex flex-col items-center justify-center py-20 px-8 bg-white rounded-[2rem] border-2 border-dashed border-slate-100">
                                        <div className="w-24 h-24 bg-purple-50 rounded-full flex items-center justify-center mb-6">
                                            <FiCheckCircle size={40} className="text-purple-200" />
                                        </div>
                                        <h3 className="text-slate-900 font-black text-xl tracking-tight">All caught up!</h3>
                                        <p className="text-slate-400 text-sm text-center mt-2 leading-relaxed">
                                            No bookings found for the selected criteria.
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* --- DESKTOP VIEW: Scrollable Table (Visible >= 768px) --- */}
                            <div className="hidden md:block bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                                <div className="overflow-x-auto overflow-y-auto max-h-[60vh]">
                                    <table className="w-full text-sm text-left border-separate border-spacing-0">
                                        <thead className="sticky top-0 z-20 bg-slate-50">
                                            <tr>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest border-b border-slate-200">Customer</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-center border-b border-slate-200">Event Info</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-center border-b border-slate-200">Created Date</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-center border-b border-slate-200">Telecaller</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-center border-b border-slate-200">Payment</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-center border-b border-slate-200">Addon's Amt</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-right border-b border-slate-200">Total</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-center border-b border-slate-200">Status</th>
                                                <th className="p-4 font-bold text-slate-500 uppercase text-[11px] tracking-widest text-right border-b border-slate-200">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-slate-100 bg-white">
                                            {bookingList && bookingList.length > 0 ? (
                                                bookingList.map((booking) => (
                                                    <tr key={booking.booking.ROWID} className="hover:bg-slate-50/50 transition-colors">
                                                        <td className="p-4">
                                                            <div className="font-bold text-slate-900">{booking.booking.customer_name}</div>
                                                            <div className="text-xs text-slate-500 font-medium">{booking.booking.customer_phone}</div>
                                                        </td>
                                                        <td className="p-4 text-center">
                                                            <div className="font-medium text-slate-700">{booking.package.name}</div>
                                                            <div className="text-[11px] text-indigo-500 font-bold uppercase whitespace-nowrap">
                                                                {booking.booking.booking_date?.split('-').reverse().join('-')} • {booking.timeSlot?.label}
                                                            </div>
                                                        </td>
                                                        <td className="p-4 text-center">{booking.booking.created_date?.split('-').reverse().join('-')}</td>
                                                        <td className="p-4 text-center font-black text-slate-500 font-medium">{booking.booking.telecaller_id !== null ? booking?.user?.name : "Admin"}</td>
                                                        <td className="p-4 text-center">
                                                            <div className="inline-flex flex-col items-start text-[11px] space-y-0.5">
                                                                <span className="text-purple-600 font-bold whitespace-nowrap">Advance: ₹{booking.booking.advance_amount}</span>
                                                                <span className="text-amber-600 font-bold whitespace-nowrap">Rest Due: ₹{booking.booking.balance_amount}</span>
                                                            </div>
                                                        </td>
                                                        <td className="p-4 text-center font-black text-slate-900">₹{booking.booking.addons_amount}</td>
                                                        <td className="p-4 text-center font-black text-slate-900">₹{booking.booking.total_amount}</td>
                                                        <td className="p-4 text-center">
                                                            <span className={`px-2.5 py-1 rounded-lg text-[11px] font-bold border ${booking.booking.status === 'BOOKED'
                                                                ? 'bg-purple-50 text-purple-700 border-purple-100'
                                                                : 'bg-slate-50 text-slate-600 border-slate-200'
                                                                }`}>
                                                                {booking.booking.status}
                                                            </span>
                                                        </td>
                                                        <td className="p-4 text-right">
                                                            <Popover
                                                                placement="bottom-end"
                                                                trigger={
                                                                    <button className="p-2 hover:bg-slate-100 rounded-full text-slate-400 hover:text-slate-600 transition-colors">
                                                                        <FiMoreHorizontal size={20} />
                                                                    </button>
                                                                }
                                                            >
                                                                <div className="flex flex-col min-w-[160px] p-1">
                                                                    <button onClick={() => handleView(booking)} className="w-full text-left px-4 py-2 text-sm hover:bg-slate-50 rounded-md">View Details</button>
                                                                    {
                                                                        (selectedStatus === 'PENDING') && (
                                                                            <>
                                                                                <button onClick={() => markComplete2(booking)} className="w-full text-left px-4 py-2 text-sm hover:bg-slate-50 rounded-md">Mark as Paid</button>
                                                                            </>
                                                                        )
                                                                    }
                                                                    {(selectedStatus === 'PENDING' || selectedStatus === 'BOOKED') && (
                                                                        <>
                                                                            <button onClick={() => handleEdit(booking)} className="w-full text-left px-4 py-2 text-sm hover:bg-slate-50 rounded-md">Edit Booking</button>
                                                                            <button onClick={() => handlePayment(booking)} className="w-full text-left px-4 py-2 text-sm text-indigo-600 font-bold hover:bg-indigo-50 rounded-md">Create Payment Link</button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </Popover>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={6} className="py-20 text-center text-slate-400 font-medium">No records found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {/* --- Pagination Section --- */}
                                <div className="px-4 py-4 flex items-center justify-between border-t border-slate-100 bg-slate-50/50">
                                    {/* Page info indicator */}
                                    <div className="text-[11px] text-slate-500 font-bold uppercase tracking-wider">
                                        {bookingList?.length > 0 ? (
                                            <span>Showing {offset + 1} - {offset + bookingList.length}</span>
                                        ) : (
                                            <span>No more records</span>
                                        )}
                                    </div>

                                    <div className="flex items-center space-x-3">
                                        <button
                                            onClick={handlePrevPage}
                                            disabled={offset === 0}
                                            className="px-4 py-2 text-xs font-bold bg-white border border-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all shadow-sm"
                                        >
                                            ← Previous
                                        </button>

                                        <button
                                            onClick={handleNextPage}
                                            disabled={isLastPage}
                                            className={`px-4 py-2 text-xs font-bold rounded-lg transition-all shadow-md 
                ${isLastPage
                                                    ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
                                                    : 'bg-indigo-600 text-white hover:bg-indigo-700 shadow-indigo-200'
                                                }`}
                                        >
                                            {isLastPage ? 'End of List' : 'Next 20 →'}
                                        </button>
                                    </div>
                                </div>
                            </div>


                            {/* --- PAGINATION CONTROLS --- */}
                            {/* <div className="flex items-center justify-between px-6 py-5 bg-white border-t border-slate-100 rounded-b-2xl shadow-sm">
                                <div className="flex flex-col">
                                    <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Current Range</span>
                                    <span className="text-sm font-bold text-slate-700">
                                        {offset + 1} — {offset + (bookingList?.length || 0)}
                                    </span>
                                </div>

                                <div className="flex gap-3">
                                    <button
                                        disabled={offset === 0}
                                        onClick={() => fetchBookingList(selectedBranch, selectedStatus, telecallerId, search, dateFrom, dateTo, offset - 20)}
                                        className="group flex items-center gap-2 px-5 py-2.5 rounded-xl border-2 border-slate-100 text-sm font-black text-slate-500 disabled:opacity-30 disabled:bg-slate-50 transition-all hover:border-[#72398E] hover:text-[#72398E]"
                                    >
                                        <FiChevronLeft className="group-hover:-translate-x-1 transition-transform" />
                                        Prev
                                    </button>

                                    <button
                                        disabled={!bookingList || bookingList.length < limit}
                                        onClick={() => fetchBookingList(selectedBranch, selectedStatus, telecallerId, search, dateFrom, dateTo, offset + 20)}
                                        className="group flex items-center gap-2 px-5 py-2.5 rounded-xl bg-[#72398E] text-white text-sm font-black shadow-lg shadow-purple-200 disabled:bg-slate-200 disabled:shadow-none disabled:cursor-not-allowed hover:bg-[#5e2e75] active:scale-95 transition-all"
                                    >
                                        Next
                                        <FiChevronRight className="group-hover:translate-x-1 transition-transform" />
                                    </button>
                                </div>
                            </div> */}
                        </div>

                        <Modal
                            open={openModal}
                            onClose={closeModal}
                            title={
                                mode === "view"
                                    ? "View Booking's"
                                    : mode === "edit"
                                        ? "Edit Booking's"
                                        : ""
                            }
                            width="w-full sm:w-[95%] md:max-w-2xl">
                            <div className="space-y-8 p-1">
                                <Notification
                                    message={toast.message}
                                    type={toast.type}
                                    onClose={() => setToast({ message: "", type: "success" })} />

                                <div>
                                    <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                        <span className="w-8 h-[1px] bg-slate-200"></span> Customer Details {formData.ROWID}
                                    </h3>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
                                        <FormInput
                                            label="Customer Name"
                                            value={formData.customer_name}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, customer_name: val }));
                                                setErrors((prev) => ({ ...prev, customer_name: null }));
                                            }}
                                            placeholder="Customer Name"
                                            disabled={mode === "view"}
                                            error={errors.customer_name}
                                        />

                                        <FormInput
                                            label="Customer Email"
                                            value={formData.customer_email}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, customer_email: val }));
                                                setErrors((prev) => ({ ...prev, customer_email: null }));
                                            }}
                                            placeholder="Customer Email"
                                            disabled={mode === "view"}
                                            error={errors.customer_email}
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <FormInput
                                            label="Customer Phone"
                                            value={formData.customer_phone}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, customer_phone: val }));
                                                setErrors((prev) => ({ ...prev, customer_phone: null }));
                                            }}
                                            placeholder="Customer Phone"
                                            disabled={mode === "view"}
                                            error={errors.customer_phone}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                        <span className="w-8 h-[1px] bg-slate-200"></span> General Details
                                    </h3>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
                                        <FormInput
                                            label="Cake note"
                                            value={formData.cake_note}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, cake_note: val }));
                                                setErrors((prev) => ({ ...prev, cake_note: null }));
                                            }}
                                            placeholder="Cake note"
                                            disabled={mode === "view"}
                                            error={errors.cake_note}
                                        />

                                        <FormInput
                                            label="Notes"
                                            value={formData.notes}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, notes: val }));
                                                setErrors((prev) => ({ ...prev, notes: null }));
                                            }}
                                            placeholder="Notes"
                                            disabled={mode === "view"}
                                            error={errors.notes}
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label className="block mb-1 text-sm font-medium text-slate-700">
                                            Booking Date
                                        </label>
                                        <BasicDatePicker valueData={formData.booking_date} disable={true} />
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5 mt-5">
                                        <div className="col-span-1 sm:col-span-2 lg:col-span-2">
                                            <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
                                                Booking Status
                                            </label>
                                            <select
                                                value={formData.status || ''}
                                                onChange={(e) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        status: e.target.value
                                                    }));
                                                }}
                                                className="w-full h-11 px-4 pr-10 rounded-xl
                                                                        border border-slate-300 bg-white
                                                                        text-sm text-slate-700
                                                                        focus:outline-none focus:ring-2 focus:ring-[#72398E]
                                                                        focus:border-[#72398E]
                                                                        transition-all duration-200
                                                                        appearance-none cursor-pointer"
                                                disabled={mode === "view"}
                                            >
                                                <option value="">Select status</option>
                                                {status.map(b => (
                                                    <option key={b.key} value={b.key}>
                                                        {b.value}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-span-1 sm:col-span-2 lg:col-span-2">
                                            <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
                                                Time-slot
                                            </label>
                                            <select
                                                value={formData.time_slot_id || ''}
                                                onChange={(e) => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        time_slot_id: e.target.value
                                                    }));
                                                }}
                                                className="w-full h-11 px-4 pr-10 rounded-xl
                                                                        border border-slate-300 bg-white
                                                                        text-sm text-slate-700
                                                                        focus:outline-none focus:ring-2 focus:ring-[#72398E]
                                                                        focus:border-[#72398E]
                                                                        transition-all duration-200
                                                                        appearance-none cursor-pointer"
                                                disabled={mode === "view"}
                                            >
                                                <option value="">Select timeslot</option>
                                                {timeSlots.map(b => (
                                                    <option key={b.time_slot_id} value={b.time_slot_id}>
                                                        {b.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                    </div>
                                </div>

                                <div>
                                    <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                        <span className="w-8 h-[1px] bg-slate-200"></span> Addon's Details
                                    </h3>

                                    <div className="space-y-4 max-h-96 overflow-y-auto">

                                        {selectedAddons && selectedAddons.length > 0 ? (
                                            <>
                                                {selectedAddons.map((addon, index) => (
                                                    <div key={index ?? addon.addon_id}>
                                                        <div
                                                            className="
                                                                relative
                                                                grid grid-cols-1
                                                                sm:grid-cols-2
                                                                lg:grid-cols-5
                                                                gap-4
                                                                p-4 bg-slate-50 rounded-xl
                                                                group hover:bg-slate-100 transition-all
                                                                "
                                                        >
                                                            {/* Addon */}
                                                            <div className="col-span-1 sm:col-span-2 lg:col-span-2">
                                                                <label className="block text-xs font-semibold text-slate-600 mb-1">
                                                                    Add-on
                                                                </label>
                                                                <select
                                                                    value={addon.addon_id || ''}
                                                                    onChange={(e) => {
                                                                        const addon_id = e.target.value;
                                                                        const selected = addons.find(a => a.ROWID === addon_id);
                                                                        setSelectedAddons(prev =>
                                                                            prev.map((item, i) =>
                                                                                i === index
                                                                                    ? {
                                                                                        ...item,
                                                                                        addon_id,
                                                                                        addon_name: selected?.name || "",
                                                                                        price: selected?.branches?.[0]['price'] || 0,
                                                                                        line_total: (item.quantity || 1) * (selected?.branches?.[0]['price'] || 0)
                                                                                    }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                    className="w-full h-11 px-4 pr-10 rounded-xl
                                                                        border border-slate-300 bg-white
                                                                        text-sm text-slate-700
                                                                        focus:outline-none focus:ring-2 focus:ring-[#72398E]
                                                                        focus:border-[#72398E]
                                                                        transition-all duration-200
                                                                        appearance-none cursor-pointer"
                                                                    disabled={addon.isExisting || mode === "view"}
                                                                >
                                                                    <option value="">Select Addon</option>
                                                                    {addons.map(b => (
                                                                        <option key={b.ROWID} value={b.ROWID}>
                                                                            {b.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            {/* Quantity */}
                                                            <div>
                                                                <label className="block text-xs font-semibold text-slate-600 mb-1">
                                                                    Quantity
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    min={0}
                                                                    value={addon.quantity || ''}
                                                                    onChange={(e) => {
                                                                        const quantity = Number(e.target.value || 0);
                                                                        setSelectedAddons(prev =>
                                                                            prev.map((item, i) =>
                                                                                i === index
                                                                                    ? {
                                                                                        ...item,
                                                                                        quantity,
                                                                                        line_total: quantity * (Number(item.price) || 0)
                                                                                    }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}

                                                                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm"
                                                                    disabled={addon.isExisting || mode === "view"}
                                                                />
                                                            </div>

                                                            {/* Price */}
                                                            <div>
                                                                <label className="block text-xs font-semibold text-slate-600 mb-1">
                                                                    Price (₹)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    value={addon.price || ''}
                                                                    onChange={(e) => {
                                                                        const price = Number(e.target.value || 0);
                                                                        setSelectedAddons(prev =>
                                                                            prev.map((item, i) =>
                                                                                i === index
                                                                                    ? {
                                                                                        ...item,
                                                                                        price,
                                                                                        line_total: price * (Number(item.quantity) || 0)
                                                                                    }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}

                                                                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm"
                                                                    disabled
                                                                />
                                                            </div>

                                                            {/* Line Total */}
                                                            <div>
                                                                <label className="block text-xs font-semibold text-slate-600 mb-1">
                                                                    Line Total (₹)
                                                                </label>
                                                                <input
                                                                    type="number"
                                                                    value={addon.line_total || ''}
                                                                    className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-slate-100"
                                                                    disabled
                                                                />
                                                            </div>

                                                            {/* Remove Button */}
                                                            {selectedAddons.length > 0 && mode !== "view" && (
                                                                <div className="flex items-end justify-end lg:justify-center">
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            setSelectedAddons(prev =>
                                                                                prev.filter((_, i) => i !== index)
                                                                            );
                                                                            removeAddons(addon);
                                                                        }}
                                                                        className="
                                                                            absolute top-3 right-3
                                                                            w-7 h-7
                                                                            flex items-center justify-center
                                                                            text-red-500 hover:text-red-700
                                                                            hover:bg-red-50 rounded-full
                                                                            transition-all
                                                                            opacity-0 group-hover:opacity-100
                                                                            "
                                                                        title="Remove"
                                                                    >
                                                                        ×
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}

                                                {mode !== "view" && (
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setSelectedAddons(prev => [
                                                                ...prev,
                                                                {
                                                                    addon_id: "",
                                                                    addon_name: "",
                                                                    price: 0,
                                                                    quantity: 1,
                                                                    line_total: 0,
                                                                    isExisting: false
                                                                }
                                                            ]);
                                                        }}
                                                        className="w-full flex items-center justify-center gap-2 px-4 py-3 mt-4 border-2 border-dashed border-slate-300 rounded-xl hover:border-blue-400 hover:bg-blue-50 transition-all text-sm font-medium text-slate-600 hover:text-blue-600"
                                                    >
                                                        ➕ Addon's
                                                    </button>
                                                )}
                                                {/* Addons Total */}
                                                <div className="flex items-center justify-between p-5 mt-5 rounded-2xl bg-slate-50 border border-slate-100 transition-all hover:bg-slate-100/50">
                                                    <div>
                                                        <p className="text-sm font-bold text-slate-700">Addon's Total</p>
                                                        <p className="text-xs text-slate-500">Quantity × Addon price</p>
                                                    </div>
                                                    <p className="text-sm font-bold text-slate-700">
                                                        (₹){addonTotalAmt}
                                                    </p>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {/* Empty State Container */}
                                                <div className="flex flex-col items-center justify-center py-10 px-4 border-2 border-dashed border-slate-200 rounded-2xl bg-slate-50/50">
                                                    <div className="bg-white p-3 rounded-full shadow-sm mb-3">
                                                        <svg
                                                            className="w-6 h-6 text-slate-400"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                                                        </svg>
                                                    </div>
                                                    <h3 className="text-slate-900 font-medium text-sm">No add-ons selected</h3>
                                                    <p className="text-slate-500 text-xs mt-1 text-center">
                                                        Enhance your order by adding extra items from the catalog.
                                                    </p>

                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            setSelectedAddons(prev => [
                                                                ...prev,
                                                                {
                                                                    addon_id: "",
                                                                    addon_name: "",
                                                                    price: 0,
                                                                    quantity: 1,
                                                                    line_total: 0,
                                                                    isExisting: false
                                                                }
                                                            ]);
                                                        }}
                                                        className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 bg-white border border-slate-200 rounded-lg shadow-sm text-sm font-semibold text-slate-700 hover:bg-blue-600 hover:text-white hover:border-blue-600 hover:shadow-blue-100 active:scale-95 transition-all duration-200"
                                                    >
                                                        <span>Add Add-on</span>
                                                    </button>
                                                </div>
                                            </>


                                        )}
                                    </div>
                                </div>

                                <div>
                                    <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                                        <span className="w-8 h-[1px] bg-slate-200"></span> Billing Details
                                    </h3>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
                                        <FormInput
                                            label="Package Amount"
                                            value={formData.package_amount}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, package_amount: val }));
                                                setErrors((prev) => ({ ...prev, package_amount: null }));
                                            }}
                                            placeholder="Package Amount"
                                            disabled={mode === "view" || mode === "edit"}
                                            error={errors.package_amount}
                                        />

                                        <FormInput
                                            label="Advance Amount"
                                            value={formData.advance_amount}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, advance_amount: val }));
                                                setErrors((prev) => ({ ...prev, advance_amount: null }));
                                            }}
                                            placeholder="Advance Amount"
                                            disabled={mode === "view" || mode === "edit"}
                                            error={errors.advance_amount}
                                        />
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5 mt-5">
                                        <FormInput
                                            label="Total Amount"
                                            value={formData.total_amount}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, total_amount: val }));
                                                setErrors((prev) => ({ ...prev, total_amount: null }));
                                            }}
                                            placeholder="Total Amount"
                                            disabled={mode === "view" || mode === "edit"}
                                            error={errors.total_amount}
                                        />

                                        <FormInput
                                            label="Balance Amount"
                                            value={formData.balance_amount}
                                            onChange={(val) => {
                                                setFormData((p) => ({ ...p, balance_amount: val }));
                                                setErrors((prev) => ({ ...prev, balance_amount: null }));
                                            }}
                                            placeholder="Balance Amount"
                                            disabled={mode === "view" || mode === "edit"}
                                            error={errors.balance_amount}
                                        />
                                    </div>
                                </div>

                                <div className="flex justify-end gap-3 pt-6 border-t border-slate-100">
                                    <button
                                        onClick={closeModal}
                                        className="px-6 py-2.5 rounded-xl text-sm font-bold text-slate-500 hover:bg-slate-100 transition-colors"
                                    >
                                        Discard
                                    </button>

                                    {mode !== "view" && (
                                        <button
                                            onClick={updateBookings}
                                            className="px-8 py-2.5 rounded-xl bg-[#72398E] text-white text-sm font-bold shadow-lg shadow-slate-200 hover:bg-purple-600 transition-all active:scale-95"
                                        >
                                            {mode === "edit" ? "Save Changes" : "Save"}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </Modal>

                        <Modal
                            open={openPaymentModal}
                            onClose={closePaymentModal}
                            title={formData.status === 'PENDING' ? "Request Advance" : "Final Settlement"}
                            width="w-full sm:w-[95%] md:max-w-xl"
                        >
                            <div className="mx-auto bg-white">
                                {formData.status === 'PENDING' ? (
                                    <div className="space-y-6">
                                        {/* Visual Header */}
                                        <div className="flex items-center gap-4 p-4 rounded-2xl bg-slate-50 border border-slate-100">
                                            <div className="w-12 h-12 rounded-xl bg-[#72398E] flex items-center justify-center text-white shadow-lg shadow-purple-200">
                                                <FiSend size={24} />
                                            </div>
                                            <div>
                                                <h2 className="text-lg font-black text-slate-800 tracking-tight">Advance Request</h2>
                                                <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Awaiting Initial Deposit</p>
                                            </div>
                                        </div>

                                        <div className="space-y-3 px-1">
                                            <p className="text-slate-600 leading-relaxed text-sm">
                                                Confirming the request will send a secure payment link for
                                                <span className="text-slate-900 font-extrabold mx-1 text-base">₹{formData.advance_amount}</span>
                                                to the customer's registered mobile and email address.
                                            </p>
                                        </div>

                                        <div className="flex flex-col sm:flex-row justify-end gap-3 pt-6 border-t border-slate-100">
                                            <button
                                                className="order-2 sm:order-1 px-6 py-3 rounded-xl text-sm font-black text-slate-400 hover:text-slate-600 transition-colors"
                                                onClick={closePaymentModal}>
                                                Cancel
                                            </button>
                                            <button
                                                className="order-1 sm:order-2 px-8 py-3 rounded-xl bg-[#72398E] text-white text-sm font-black shadow-xl shadow-purple-200 hover:bg-[#5e2e75] transition-all active:scale-95 flex items-center justify-center gap-2"
                                                onClick={() => sendPaymentLink('PENDING')}>
                                                Send Payment Link <FiChevronRight />
                                            </button>
                                        </div>
                                    </div>
                                ) : formData.status === 'BOOKED' ? (
                                    <div className="space-y-6">
                                        {/* Summary Card */}
                                        <div className="p-5 rounded-2xl bg-[#72398E]/5 border border-purple-100 flex justify-between items-center">
                                            <div>
                                                <span className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">Paid Advance</span>
                                                <span className="text-xl font-black text-slate-900">₹{formData.advance_amount}</span>
                                            </div>
                                            <div className="text-right">
                                                <span className="block text-[10px] font-black text-[#72398E] uppercase tracking-widest mb-1">Total Due</span>
                                                <span className="text-2xl font-black text-[#72398E]">₹{newTotalAmount}</span>
                                            </div>
                                        </div>

                                        {/* Input Section */}
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div className="space-y-1.5">
                                                <label className="text-[10px] font-black text-slate-400 uppercase ml-1">Balance Due</label>
                                                <div className="px-4 py-3 rounded-xl bg-slate-50 border border-slate-200 text-slate-500 font-bold text-sm">
                                                    ₹{balanceAmount}
                                                </div>
                                            </div>
                                            <div className="space-y-1.5">
                                                <label className="text-[10px] font-black text-[#72398E] uppercase ml-1">Add Extra Charges</label>
                                                <input
                                                    type="number"
                                                    value={extraAmtDue || ""} // Shows empty box instead of 0 if preferred
                                                    onChange={(e) => handleExtraAmt(e.target.value)}// Passes the event 'e' automatically
                                                    placeholder="0.00"
                                                    className="w-full px-4 py-3 rounded-xl border-2 border-slate-100 focus:border-[#72398E] focus:outline-none font-bold text-slate-900"
                                                />
                                            </div>
                                        </div>

                                        {/* Actions */}
                                        <div className="space-y-3 pt-2">
                                            <div className="flex flex-col sm:flex-row gap-3">
                                                <button
                                                    onClick={() => markComplete(newTotalAmount)}
                                                    className="flex-1 flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-slate-900 text-white text-sm font-black transition-all hover:bg-black active:scale-95"
                                                >
                                                    <FiDollarSign /> Mark as Paid (Cash)
                                                </button>
                                                <button
                                                    onClick={() => sendPaymentLink('BOOKED')}
                                                    className="flex-1 flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-[#72398E] text-white text-sm font-black shadow-lg shadow-purple-100 hover:bg-[#5e2e75] active:scale-95"
                                                >
                                                    <FiLink /> Send Link
                                                </button>
                                            </div>
                                            <button
                                                className="w-full py-2 text-[11px] font-black text-slate-300 uppercase tracking-widest hover:text-slate-500 transition-colors"
                                                onClick={closePaymentModal}>
                                                Close Window
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </Modal>
                    </div>
                </>
            }
        </>
    )
}

function FormInput({
    label,
    value,
    onChange,
    placeholder,
    readOnly,
    disabled,
    type = "text",
    error
}) {
    return (
        <div className="flex flex-col">
            <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
                {label}
            </label>
            <input
                type={type}
                placeholder={placeholder}
                value={value || ""}
                readOnly={readOnly}
                disabled={disabled}   // ✅ apply it here
                onChange={(e) => onChange(e.target.value)}
                className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none 
            ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
            ${(readOnly || disabled)
                        ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
                        : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
          `}
            />
            {error && (
                <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
                    {error}
                </span>
            )}
        </div>
    );
}

const MobileEmptyState = () => (
    <div className="flex flex-col items-center justify-center py-12 px-4 bg-white rounded-2xl border border-dashed border-slate-200">
        <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center text-2xl mb-4">
            📦
        </div>
        <h3 className="text-slate-900 font-bold text-lg">No Bookings Found</h3>
        <p className="text-slate-500 text-sm text-center mt-1">
            There are no bookings available for this branch at the moment.
        </p>
    </div>
);
export default ListBookings